<template>
  <div class="form-group">
    <label>{{ title }}</label>
    <b class="form-control" readonly v-if="readOnly">{{ value }}</b>
    <input class="form-control" :class="errors ? 'is-invalid' : ''" v-if="!readOnly" type="text" :placeholder="placeholder" @change="onChange()" @keyup="onChange()" v-model="elementValue" />
    <small class="form-text text-muted" v-if="hint">{{ hint }}</small>
    <ErrorsForm :errors="errors" />
  </div>
</template>

<script>
import ErrorsForm from "./ErrorsForm.vue";

export default {

  name: "TextForm",
  
  components: {
    ErrorsForm
  },

  data() {
    return {
      elementValue: this.value
    }
  },
  
  props: {
    title: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: ""
    },
    hint: {
      type: String,
      default: ""
    },
    value: {},
    readOnly: {
      type: Boolean
    },
    errors: {
      type: Array
    }
  },
  
  methods: {
    onChange() {
      this.$emit('value', this.elementValue);
    }
  }
}

</script>

<style>

</style>